/* Nordik Recovery — Maintenance & Support Hub
 * Instance-scoped, vanilla JS.
 * - Fold (lanes + Guard cards) is server-rendered; JS only wires navigation.
 * - Taxonomy is inlined (no fetch): read from <script class="nmh-taxonomy">.
 * - Product data (image/thumb/price) inlined from <script class="nmh-products">.
 * - All Zendesk-sourced strings are HTML-escaped before insertion.
 */
(function () {
  'use strict';

  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function track(ev, p) { window.dataLayer = window.dataLayer || []; var o = { event: ev }; for (var k in p) o[k] = p[k]; window.dataLayer.push(o); }

  var GX = '<svg class="nmh-gx" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var NEEDLABEL = { setup: 'Quick Start / Setup', maintenance: 'Maintenance & Care', troubleshooting: 'Troubleshooting', general: 'More guides' };
  var NEEDORDER = ['setup', 'maintenance', 'troubleshooting', 'general'];

  function hl(title, q) {
    if (!q) return esc(title);
    var lt = title.toLowerCase(), lq = q.toLowerCase(), i = lt.indexOf(lq);
    if (i < 0) return esc(title);
    return esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + q.length)) + '</mark>' + esc(title.slice(i + q.length));
  }

  function initHub(root) {
    if (root.__nmhInit) return; root.__nmhInit = true;

    var DATA, products = {}, overrides = {};
    try { DATA = JSON.parse(root.querySelector('.nmh-taxonomy').textContent || 'null'); } catch (e) { DATA = null; }
    try { products = JSON.parse(root.querySelector('.nmh-products').textContent || '{}'); } catch (e) { products = {}; }
    try { var ovEl = root.querySelector('.nmh-overrides'); overrides = ovEl ? (JSON.parse(ovEl.textContent || '{}') || {}) : {}; } catch (e) { overrides = {}; }
    var lanecfg = {};
    try { var lcEl = root.querySelector('.nmh-lanecfg'); lanecfg = lcEl ? (JSON.parse(lcEl.textContent || '{}') || {}) : {}; } catch (e) { lanecfg = {}; }
    if (!DATA) return; // fold is still server-rendered even if JS can't parse

    var state = { lane: null, product: null, q: '' };
    var input = root.querySelector('.nmh-input');
    var q = function (sel) { return root.querySelector(sel); };
    var views = {};
    ['home', 'lane', 'product', 'search'].forEach(function (v) { views[v] = q('[data-view="' + v + '"]'); });
    var faqSec = q('[data-faq-sec]');

    var famByKey = {}, laneByKey = {}, laneOfFam = {};
    DATA.lanes.forEach(function (l) { if (lanecfg[l.key]) l.label = lanecfg[l.key]; laneByKey[l.key] = l; l.families.forEach(function (f) { famByKey[f.key] = f; laneOfFam[f.key] = l.key; }); });
    if (DATA.guard) famByKey[DATA.guard.key] = DATA.guard;

    /* ---- HOME (lanes + guard are server-rendered; JS builds only the FAQ) ---- */
    var faqBuilt = false;
    function buildHome() {
      if (faqBuilt) return; faqBuilt = true;
      var fc = q('[data-faqcols]'), tabsEl = q('[data-faqtabs]');
      if (!fc || !DATA.faq) return;
      fc.innerHTML = ''; if (tabsEl) tabsEl.innerHTML = '';
      var cols = [];
      DATA.faq.forEach(function (g, i) {
        var col = document.createElement('div'); col.className = 'nmh-faqcol' + (i === 0 ? ' nmh-faqcol--active' : '');
        col.setAttribute('role', 'tabpanel');
        col.innerHTML = '<h3>' + esc(g.label) + '</h3>' + g.articles.map(function (a) {
          return '<div class="nmh-qa"><a href="' + esc(a.url) + '" target="_blank" rel="noopener">' + esc(a.title) + '</a></div>';
        }).join('');
        fc.appendChild(col); cols.push(col);
      });
      // Tabs are CSS-hidden on desktop (both columns show); they only drive the mobile one-at-a-time view.
      if (tabsEl && DATA.faq.length > 1) {
        DATA.faq.forEach(function (g, i) {
          var t = document.createElement('button'); t.type = 'button'; t.className = 'nmh-faqtab'; t.setAttribute('role', 'tab');
          t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          t.innerHTML = esc(g.label) + ' <span class="nmh-faqcount">' + g.articles.length + '</span>';
          t.addEventListener('click', function () {
            cols.forEach(function (c, ci) { c.classList.toggle('nmh-faqcol--active', ci === i); });
            [].forEach.call(tabsEl.children, function (b, bi) { b.setAttribute('aria-selected', bi === i ? 'true' : 'false'); });
            track('hub_faq_tab', { group: g.key || g.label });
          });
          tabsEl.appendChild(t);
        });
      }
    }

    /* ---- LANE ---- */
    function openLane(key) { state.lane = key; state.product = null; state.q = ''; if (input) input.value = ''; sync(); render(); track('hub_lane_click', { lane: key }); }
    function buildLane() {
      var l = laneByKey[state.lane]; if (!l) return;
      q('[data-lane-title]').textContent = l.label;
      setCrumb(views.lane, [{ home: true }, { here: l.label }]);
      var t = q('[data-ptiles]'); t.innerHTML = '';
      l.families.forEach(function (f) {
        var p = products[f.heroHandle], img = overrides[f.key] || (p && p.image ? p.image : '');
        var b = document.createElement('button'); b.type = 'button'; b.className = 'nmh-ptile';
        b.innerHTML = '<div class="nmh-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(f.label) + '" loading="lazy">' : '') + '</div>' +
          '<div class="nmh-body"><h3>' + esc(f.label) + '</h3><div class="nmh-c">' + f.count + ' guides <svg class="nmh-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></div></div>';
        b.addEventListener('click', function () { openProduct(f.key); });
        t.appendChild(b);
      });
    }

    /* ---- PRODUCT HUB ---- */
    function openProduct(key) { state.product = key; state.lane = laneOfFam[key] || state.lane; state.q = ''; if (input) input.value = ''; sync(); render(); track('hub_product_click', { product: key }); }
    function guideRow(a) {
      var shop = '';
      if (a.shop && products[a.shop.handle]) {
        var p = products[a.shop.handle];
        shop = '<a class="nmh-shopchip" href="' + esc(p.url) + '" target="_blank" rel="noopener" data-stop>Shop · ' + esc(p.price) + '</a>';
      }
      return '<a class="nmh-glink" href="' + esc(a.html_url) + '" target="_blank" rel="noopener" data-article="' + esc(a.id) + '"><span>' + hl(a.title, state.q) + '</span>' + shop + GX + '</a>';
    }
    function buildProduct() {
      var f = famByKey[state.product]; if (!f) return;
      q('[data-product-title]').textContent = f.label;
      var l = laneByKey[state.lane];
      var crumbs = [{ home: true }];
      if (l) crumbs.push({ lane: l.key, label: l.label });
      crumbs.push({ here: f.label });
      setCrumb(views.product, crumbs);

      var arts = DATA.articles.filter(function (a) { return a.family === state.product; });
      var guides = q('[data-guides]'); guides.innerHTML = '';

      if (f.maint) {
        var mic = '<svg class="nmh-mic" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 2s5 5.5 5 10a5 5 0 0 1-10 0C7 7.5 12 2 12 2Z"/></svg>';
        var mar = '<svg class="nmh-marrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        var inner = mic + '<div><div class="nmh-mt">Maintenance protocol for this model</div><div class="nmh-ms">Descaling schedule, water care and step-by-step upkeep.</div></div>' + mar;
        var mc = document.createElement('a'); mc.className = 'nmh-maint';
        if (f.maint.href) { mc.href = f.maint.href; mc.target = '_blank'; mc.rel = 'noopener'; mc.addEventListener('click', function () { track('hub_maint_link', { product: state.product, type: 'section' }); }); }
        else if (f.maint.app) { mc.href = '#'; mc.addEventListener('click', function (e) { e.preventDefault(); track('hub_maint_link', { product: state.product, type: 'hub' }); openProduct(f.maint.app); }); }
        mc.innerHTML = inner; guides.appendChild(mc);
      }

      var present = NEEDORDER.filter(function (nk) { return arts.some(function (a) { return a.need === nk; }); });
      var loneGeneral = present.length === 1 && present[0] === 'general';
      present.forEach(function (nk) {
        var grp = arts.filter(function (a) { return a.need === nk; });
        var col = document.createElement('div'); col.className = 'nmh-needcol';
        var label = (loneGeneral && nk === 'general') ? 'Guides' : NEEDLABEL[nk];
        col.innerHTML = '<h4>' + esc(label) + '</h4>' + grp.map(guideRow).join('');
        guides.appendChild(col);
      });

      var rail = q('[data-rail]');
      var strip = (f.strip || []).map(function (h) { return products[h]; }).filter(Boolean);
      if (strip.length) {
        rail.innerHTML = '<div class="nmh-rail"><h4>Care &amp; re-order</h4><div class="nmh-rsub">Keep your ' + esc(f.label) + ' running at its best.</div>' +
          strip.map(function (p) {
            var meta = p.available ? esc(p.price) : esc(p.price) + ' · currently unavailable';
            var img = p.thumb || p.image || '';
            return '<a class="nmh-rprod" href="' + esc(p.url) + '" target="_blank" rel="noopener" data-product="' + esc(p.handle || '') + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              '<div><div class="nmh-rt">' + esc(p.title) + '</div><div class="nmh-rp">' + meta + '</div></div></a>';
          }).join('') + '</div>';
      } else { rail.innerHTML = ''; }
    }

    /* ---- SEARCH ---- */
    function buildSearch() {
      var nq = norm(state.q);
      var arts = DATA.articles.filter(function (a) { return norm(a.title).indexOf(nq) >= 0 || norm(a.section_name || '').indexOf(nq) >= 0; });
      q('[data-search-title]').textContent = '“' + state.q + '”';
      q('[data-search-eyebrow]').textContent = arts.length + ' result' + (arts.length === 1 ? '' : 's');
      setCrumb(views.search, [{ home: true }, { here: 'Search' }]);
      q('[data-empty]').hidden = arts.length > 0;
      var groups = {};
      arts.forEach(function (a) { var f = famByKey[a.family]; var label = f ? f.label : 'Other'; (groups[label] = groups[label] || []).push(a); });
      var res = q('[data-results]'); res.innerHTML = '';
      Object.keys(groups).forEach(function (label) {
        var g = document.createElement('div'); g.className = 'nmh-resgroup';
        g.innerHTML = '<div class="nmh-rglabel">' + esc(label) + '</div>' + groups[label].map(guideRow).join('');
        res.appendChild(g);
      });
    }

    function setCrumb(viewEl, parts) {
      var c = viewEl.querySelector('[data-crumb]'); if (!c) return;
      c.innerHTML = parts.map(function (p, i) {
        var sep = i > 0 ? '<span class="nmh-sep">/</span>' : '';
        if (p.home) return sep + '<button type="button" data-home>Support hub</button>';
        if (p.lane) return sep + '<button type="button" data-crumb-lane="' + esc(p.lane) + '">' + esc(p.label) + '</button>';
        return sep + '<span class="nmh-here">' + esc(p.here) + '</span>';
      }).join('');
    }

    function render() {
      var view = state.q ? 'search' : state.product ? 'product' : state.lane ? 'lane' : 'home';
      ['home', 'lane', 'product', 'search'].forEach(function (v) { if (views[v]) views[v].hidden = v !== view; });
      if (faqSec) faqSec.hidden = view !== 'home';
      if (view === 'home') buildHome();
      else if (view === 'lane') buildLane();
      else if (view === 'product') buildProduct();
      else if (view === 'search') buildSearch();
      if (view !== 'home' && !root.__first) { try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { } }
      root.__first = false;
    }

    function sync() {
      var p = new URLSearchParams(location.search);
      p.delete('lane'); p.delete('product'); p.delete('q');
      if (state.q) p.set('q', state.q);
      else { if (state.lane) p.set('lane', state.lane); if (state.product) p.set('product', state.product); }
      var qs = p.toString();
      history.replaceState(null, '', qs ? ('?' + qs) : location.pathname);
    }
    function restore() {
      var p = new URLSearchParams(location.search);
      state.q = p.get('q') || '';
      state.product = p.get('product');
      state.lane = p.get('lane') || (state.product ? laneOfFam[state.product] : null);
      if (input) input.value = state.q;
      root.__first = true;
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      var stop = e.target.closest('[data-stop]'); if (stop) e.stopPropagation();
      var laneCard = e.target.closest('.nmh-lane[data-lane]');
      if (laneCard) { openLane(laneCard.getAttribute('data-lane')); return; }
      var home = e.target.closest('[data-home]');
      if (home) { state.lane = null; state.product = null; state.q = ''; if (input) input.value = ''; sync(); render(); return; }
      var clane = e.target.closest('[data-crumb-lane]');
      if (clane) { state.lane = clane.getAttribute('data-crumb-lane'); state.product = null; state.q = ''; if (input) input.value = ''; sync(); render(); return; }
      var gl = e.target.closest('.nmh-glink'); if (gl && gl.dataset.article) track('hub_article_click', { id: gl.dataset.article });
      var rp = e.target.closest('.nmh-rprod'); if (rp && rp.dataset.product) track('hub_product_strip_click', { handle: rp.dataset.product });
    });

    var gopen = root.querySelector('[data-guard-open]');
    if (gopen) gopen.addEventListener('click', function () { openProduct('nordik-guard'); });

    if (input) {
      var deb;
      input.addEventListener('input', function (e) {
        clearTimeout(deb);
        var v = e.target.value.trim();
        deb = setTimeout(function () { state.q = v; sync(); render(); if (v) track('hub_search', { query: v }); }, 220);
      });
    }

    restore(); render();
  }

  function boot() { document.querySelectorAll('.nmh').forEach(initHub); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('.nmh') : null;
    if (r) { r.__nmhInit = false; initHub(r); }
  });
})();
